import { createFileRoute } from "@tanstack/react-router";
import GettingStarted from "@/pages/GettingStarted";

export const Route = createFileRoute("/getting-started/")({
  component: GettingStarted,
});
